import { render, staticRenderFns } from "./ComparisonColourPickerModal.vue?vue&type=template&id=70583ef8"
import script from "./ComparisonColourPickerModal.vue?vue&type=script&lang=ts"
export * from "./ComparisonColourPickerModal.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonColourPickerModal.vue?vue&type=style&index=0&id=70583ef8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports